const HERO_BG =
  "https://images.pexels.com/photos/32901670/pexels-photo-32901670.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const HERO_LOUNGE =
  "https://images.pexels.com/photos/40258716/pexels-photo-40258716.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Hero = () => (
  <header
    id="hero"
    data-testid="hero-section"
    className="relative py-20 md:py-28 px-8 border-b border-[#E3DFD5] overflow-hidden"
  >
    {/* Full-width Namibian landscape with subtle dark overlay */}
    <img
      src={HERO_BG}
      alt="Namibian desert mountains at sunset"
      data-testid="hero-bg-image"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-[#0A192F]/60" />

    <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6 space-y-6">
        <span
          className="inline-block font-mono-tag text-xs tracking-[0.25em] text-[#D9C29A] uppercase fade-in"
          style={{ animationDelay: "0.1s" }}
        >
          Warmth • Comfort • Distinction
        </span>

        <h1
          data-testid="hero-headline"
          className="font-editorial text-4xl sm:text-6xl text-white leading-[1.05] tracking-tight"
        >
          Where travellers feel genuinely at home.
        </h1>

        <p
          className="font-grotesk text-[#EDE8DC] text-base md:text-lg max-w-lg leading-relaxed fade-in"
          style={{ animationDelay: "0.4s" }}
        >
          Quiet luxury on Hindenburg Street. Featuring 15 private guest rooms, an
          artisanal restaurant, and a welcoming lounge bar.
        </p>

        <div className="flex flex-wrap gap-4 pt-4 fade-in" style={{ animationDelay: "0.6s" }}>
          <a
            href="#booking"
            data-testid="hero-book-button"
            className="px-8 py-4 bg-[#0A192F] text-white font-grotesk text-xs uppercase tracking-[0.16em] border border-white/30 hover:bg-[#9E7D4E] hover:border-[#9E7D4E] transition-colors"
          >
            Book via WhatsApp / Form
          </a>
          <a
            href="#suites"
            data-testid="hero-explore-button"
            className="px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/40 text-white font-grotesk text-xs uppercase tracking-[0.16em] hover:bg-white hover:text-[#1A1A18] transition-colors"
          >
            Explore 15 Rooms
          </a>
        </div>
      </div>

      {/* Spotlight clipped frame */}
      <div className="lg:col-span-6">
        <div className="wipe-frame relative w-full aspect-[4/3] rounded-3xl overflow-hidden shadow-xl border border-white/20 bg-[#EBE7DD]">
          <img
            src={HERO_LOUNGE}
            alt="Warm guesthouse lounge with leather armchairs in soft sunlight"
            data-testid="hero-lounge-image"
            className="absolute inset-0 w-full h-full object-cover drift-frame"
          />
          <div className="absolute bottom-6 left-6 p-4 bg-white/90 backdrop-blur-md rounded-xl border border-white/50">
            <div className="font-mono-tag text-[9px] uppercase tracking-widest text-[#9E7D4E]">
              Otjiwarongo, Namibia
            </div>
            <div className="font-editorial text-sm text-[#1A1A18]">
              Spotless Suites &amp; Tranquil Grounds
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
);
